import { IConfigModule } from 'build/types/configs'

const config: IConfigModule = {
  version: '2.0.0',
  usePoints: true,
  filterPrizes: true,
  buttonsStart: ['google', 'facebook'],
  positiveLogoUrls: [],
  useSecondBackground: [],
  imageStart: 'imageAndText',
  welcome: 'ImgAndText',
  legalAgeDate: true,
  routesLinks: [],
  routesHome: [],
  routesProfile: ['history', 'identificacion', 'preferences'],
  privacyPolitics: 'MX',
  cookies: 'MX',
  notAvailableFields: ['instagram', 'consumptionCenter', 'nickName', 'sign'],
  trivia: {
    showIntroduction: false,
    interestsRequired: true
  },
  notShowFields: ['instagram'],
  modalBackgroundTrivias: false,
  error: {
    dontUseSecondBg: false
  },
  showPointsId: false,
  showModalMemorama: true,
  memorama: {
    dontShouldUseWhiteBg: true
  },
  album: {
    Foto: {
      list: {
        urlRedirectAlbumComplete: '/home',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true,
        useCongratsDirect: true,
      }
    },
    Card: {
      list: {
        handleClick: true,
        urlRedirectAlbumProgress: '/album/:id/ranking'
      },
      ranking: {
        titleUpload: true,
        viewMore: false,
        showSocial: 'like'
      },
      imageId: {
        showSocial: 'like'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        useLoaderValidate: true
      },
      congrats: {
        showButton3: true
      },
      profile: {
        showSocial: 'share',
        profileMultimediaOutputShare: 'base64'
      }
    },
    Ticket: {
      list: {
        urlRedirectAlbumComplete: '/album/start',
        urlRedirectAlbumProgress: '/album/:id/upload'
      },
      upload: {
        showHowToParticipate: true,
        validate: true,
        isTakeFoto: false,
        useLoaderValidate: true,
        useCongrats: true,
        useCongratsDirect: true,
        howTakePhoto: false
      }
    }
  },
  captureBtnBgTransparent: true,
  useSecondTextureUrl: [],
  stepsNewVersion: true,
  prizes: {
    description: true,
    dontShowButtonCongrats: true
  },
  useImgInHome: false,
  addressUpdateBg: true,
  dontUseTexture: [],
  profile: {
    notShowButtonInformation: true,
    showButtonPoints: true
  },
  allowReferral: true,
  usePointsHome: true,
  wheel: {
    backgroundColors: ['#F1F1F1', '#FFF'],
    textColors: ['#005F21', '#005F21'],
    outerBorderColor: '#4DA32F',
    outerBorderWidth: 0,
    innerBorderColor: '#4DA32F',
    innerBorderWidth: 20,
    innerRadius: 0,
    radiusLineColor: 'transparent',
    radiusLineWidth: 0,
    fontFamily: 'HeinekenSans',
    fontWeight: '700',
    fontSize: 10.6,
    fontStyle: 'normal',
    textDistance: 60,
    perpendicularText: true
  },
  changeIdQr: false,
  versionPh: 'v2',
  placeholderDifferent: true,
  collections: {
    gamesStickers: true
  },
  rankingAll: true
}

export default config
